import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import store from '../../store'
import { SET_GLOBAL_LOADING } from '../../store/mutation-types'
import seo from './seo'
import hashScroll from './hashScroll'
import { faseLocale } from '@/queries/fasi.js'

const dataLoad = {
  mixins: [ seo, hashScroll ],
  props: {
    type: {
      type: String,
      required: false
    }
  },
  computed: {
    ...mapGetters([
      'page',
      'loading'
    ]),
    pageApiData: {
      get () {
        return this.page(this.lang, this.$route.meta.pageName, this.type)
      }
    }
  },
  async beforeRouteEnter (to, from, next) {
    // set env to loading
    store.commit(SET_GLOBAL_LOADING, true)
    // extract language
    const lang = _.split(to.name, '-')[0] || 'it'
    // start loading
    await store.dispatch('loadPageData', { pageName: to.meta.pageName, lang, type: to.params.type })
    store.commit(SET_GLOBAL_LOADING, false)
    // we finished!
    next(async vm => {
      if (to.hash) vm.$_scrollToHash(to.hash)
      if (vm.$route.name.includes('come-funziona-sub')) {
        let slugLang
        if (vm.$route.params.type === 'stoccaggio' || vm.$route.params.type === 'essiccazione' || vm.$route.params.type === 'pirolisi' || vm.$route.params.type === 'gassificazione' || vm.$route.params.type === 'produzione-di-energia') {
          slugLang = 'it'
        } else {
          slugLang = 'en'
        }
        if (lang !== slugLang) {
          const fase = await vm.$apollo.provider.defaultClient.query({
            query: faseLocale,
            variables: {
              locale: slugLang,
              slug: vm.$route.params.type
            }
          })
            .then(({ data }) => data.fasi._allSlugLocales)
          const paramToRedirect = fase.find(el => el.locale === vm.lang).value
          vm.$router.replace({ name: `${vm.lang}-come-funziona-sub`, params: { type: paramToRedirect } })
        }
      }
    })
  },
  methods: {
    ...mapActions([
      'loadPageData'
    ])
  }
}

export default dataLoad
